var _a, _a2, _a3, _a4, _a5, _a6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 432",
    xmlSpace: "preserve",
    className: "hero__svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "#novaScotia",
    "aria-label": "Jump to Nova Scotia"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Nova Scotia"), /*#__PURE__*/React.createElement("polygon", {
    points: "365,240.9 365.1,241.6 364.3,241.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "363.3,243.8 363.7,242.5 362.4,241.7 361.4,242.4 360.1,242.4 359.3,241.7 358.6,243.3 358.1,244.1  357.9,244.6 357.2,244.7 356.5,245.3 356.4,244.5 354.5,245.2 354,245.7 352.3,245.6 351.5,246.2 350.4,245.9 349.5,245.9  349,246.9 348.8,247.9 347.9,251.2 347.6,252.8 348.3,252.7 348.6,252.1 350.2,251.2 351.5,250.4 353.1,249.6 354.7,248.9  352.7,250.8 351.9,252 352.3,253.3 351.5,253 350.8,252.8 349.8,251.9 349.1,253.6 348.2,255 346.7,257.9 345.9,259.7 346.8,258.7  345.6,260.5 344.8,262.7 345.7,261 345.5,264.8 347.5,267.5 348.1,266.8 349.4,267.9 350,268.1 350.3,267.7 350.6,267.7  350.9,267.7 351,267.5 351.4,267.1 351.4,265.6 352.2,264.9 352.7,263.4 353.1,261.9 353.2,260.9 353.5,260.3 353.6,259.6  353.6,259.2 353.8,259.1 353.3,258.1 353.7,256.6 354.3,257.1 354.2,255.7 356.2,256.1 356,254.4 357.5,253.9 357.9,253.1  358.5,252.7 360.7,249.9 362.8,246.7 363.8,245.5 364.7,244.2 365.4,243.7 365.2,243  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "367.6,235 367.8,236.2 367.4,237.8 365,240.5 363.4,241.8 361.9,241.1 360.8,237.2 360.7,233  361.9,229.4 363.3,231.4 363.8,234 364.3,235.3 363.9,236.6 362.8,238.8 363.7,237.8 363.3,239 363.9,240.3 364.5,239.5  365.2,238.9 365.5,236.8 364.4,237.6 364.6,236.6 364.4,236.1 364.7,234.4 365.7,234.6  "
  })))), _a2 || (_a2 = /*#__PURE__*/React.createElement("a", {
    href: "#ontario",
    "aria-label": "Jump to Ontario"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Ontario"), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "300,273.5 289.9,277.9 285,275.5 276.4,274.4 268.7,267.6 262.7,239.4 245.3,226.4 240.2,210.2  226.7,210.5 208.5,202.9 208.3,203.1 184.2,237.9 185.8,262.3 189.2,269.8 216.4,272.9 222.2,264.1 231.6,264.2 236.6,269.7  241.5,269.8 247.7,279.3 266,279.7 274.7,287.4 273.3,289.7 266.1,289.6 265.9,301.4 262,313.4 282.2,300.6 280.9,298 277.1,299  279.3,294.1 293.2,286.7 299.4,277.4 303.4,275.7 303.2,275.3 "
  })))), _a3 || (_a3 = /*#__PURE__*/React.createElement("a", {
    href: "#britishColumbia",
    "aria-label": "Jump to British Columbia"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "British Columbia"), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "21.1,228.2 27.3,242.9 37.1,254.4 38.4,254.2 38.4,249.9 34.5,244.2 31.9,235.3 24.1,228.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "12.3,193.7 11,198.3 11.2,204.5 13.2,213.1 14.1,203 12.3,201.8 14.4,200.6 17.5,196.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "84.9,251.6 66,218.5 81.2,169.6 47.3,158.8 15.7,140.4 14.9,150.9 17.9,150.6 20.3,149.1 25.3,149.4  25.9,178.1 30.1,184.5 22,201.8 26.9,209.5 25.4,221.8 25.3,225.9 27.2,229 35.4,235.2 43,250.7 86.3,261.7 83,257.7  "
  })))), _a4 || (_a4 = /*#__PURE__*/React.createElement("a", {
    href: "#alberta",
    "aria-label": "Jump to Alberta"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Alberta"), /*#__PURE__*/React.createElement("polyline", {
    className: "svg__fill",
    points: "81,169.7 65.8,218.6 84.7,251.7 82.8,257.8 86.2,261.8 107.5,265.3 107.6,265.3 120.1,177.7 81,169.7  "
  })))), _a5 || (_a5 = /*#__PURE__*/React.createElement("a", {
    href: "#yukon",
    "aria-label": "Jump to Yukon"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Yukon"), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "65.9,165.1 66,157.3 57.4,155.3 59.2,150.1 54.4,143.7 57.4,131.8 57.4,124.7 53.7,117.1 58.2,111.1  53.7,109.2 58.8,102.5 53.5,99.9 61.1,85.8 57,77.1 54.6,75 10.3,134.3 15.9,138.5 15.7,140.8 47.3,159.1 47.3,159.1 "
  })))), _a6 || (_a6 = /*#__PURE__*/React.createElement("a", {
    href: "#quebec",
    "aria-label": "Jump to Quebec"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Quebec"), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "329.3,201.4 326.7,199.1 328.2,197 323.8,194.2 326.3,205.9 316.8,206.8 315.8,201.9 305.2,195.8 304.4,184.4  311.2,186.2 320.1,183.1 317.4,176.1 311.2,172.2 306.9,162 299.3,155.9 293.4,145.9 293.4,145.9 295.3,156.3 292,163.9  282.5,162.4 274.5,148.1 267.4,149.9 264.1,146.9 255.3,143.5 253.5,147 241.8,147.9 241.4,151.2 244.9,154.6 244.7,160.8  250.5,167.7 248.9,177.4 258.5,183.5 262.4,192 261.6,200.2 254.1,210.1 264.8,226.9 263,239.1 262.9,239 268.8,267.3 276.5,274  285.2,275.2 290.1,277.6 300.1,273.2 303.9,275.2 316.7,270 320.8,247 325.8,245.7 323.6,241.2 325.5,238.2 329.5,238.2  331.4,236.2 337.6,233.2 338.8,225.9 332.5,225.4 321.1,238 316.8,250.5 313,256.2 313.8,254.2 319.1,233.6 323,227 322.5,219.9  345.9,208.9 351.1,204.2 352.9,193.8 356,187.6 354.1,185.3  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapM);
export default __webpack_public_path__ + "static/media/mapM.38b7a02d06b0fd559d3c2db5daf4c885.svg";
export { ForwardRef as ReactComponent };